const median = (numbers: number[]): number => {
  const sorted = [...numbers].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0
    ? (sorted[mid - 1] + sorted[mid]) / 2
    : sorted[mid];
};

// Theil–Sen estimator: median of pairwise slopes. Robust to outliers
// (breakdown ~29%), unlike OLS where endpoint leverage tilts the line.
const computeTrendLine = ({ values }: { values: number[] }): number[] => {
  const finite = values
    .map((value, index) => ({ value, index }))
    .filter((entry) => Number.isFinite(entry.value));

  if (finite.length === 0) {
    return values.map(() => NaN);
  }

  if (finite.length === 1) {
    const constant = finite[0].value;
    return values.map(() => constant);
  }

  const slopes: number[] = [];
  for (let i = 0; i < finite.length; i++) {
    for (let j = i + 1; j < finite.length; j++) {
      const dx = finite[j].index - finite[i].index;
      slopes.push((finite[j].value - finite[i].value) / dx);
    }
  }
  const slope = median(slopes);

  const intercept = median(
    finite.map((entry) => entry.value - slope * entry.index),
  );

  return values.map((_value, index) => slope * index + intercept);
};

export default computeTrendLine;
